import { useCallback, useEffect } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { useKeyPress } from "@/core/keyPressManager";
import { BackBtn } from "@/shared/ui";
import { Layer } from "@/domains/createCharacter/constants/layer";
import { currLayerSelector } from "@/domains/layer/slice";
import useConfirmBack from "@/domains/createCharacter/hooks/useConfirmBack";
import CreateCharacterConfirmBackModal from "@/domains/createCharacter/containers/modals/CreateCharacterConfirmBackModal";
import KeyCode from "@/assets/constants/key-code";

export default function CreateCharacterBackBtnContainer() {
  const { subscribeKeyDown, unsubscribeKeyDown } = useKeyPress();
  const { back, closeHandler, open, openHandler } = useConfirmBack();
  const currLayer = useAppSelector(currLayerSelector);

  const backHandler = useCallback(
    (key: KeyCode) => {
      if (currLayer !== Layer) return;
      switch (key) {
        case KeyCode.ESCAPE: {
          openHandler();
          break;
        }

        default:
          break;
      }
    },
    [openHandler, currLayer],
  );

  useEffect(() => {
    const key = "escape-back-btn-handler";
    subscribeKeyDown(key, backHandler);

    return () => {
      unsubscribeKeyDown(key);
    };
  }, [backHandler, subscribeKeyDown, unsubscribeKeyDown]);

  return (
    <>
      <CreateCharacterConfirmBackModal open={open} onConfirm={back} onCancel={closeHandler} />
      <BackBtn
        className="absolute left-[--boundary-offset-x] top-[--boundary-offset-x]"
        onClick={openHandler}
      />
    </>
  );
}
